import apiClient from './apiClient';

export type ReportPeriod = 'weekly' | 'monthly';
export type ReportKind = 'weekly' | 'trial_end';
export type ReportStatus = 'pending' | 'generating' | 'ready' | 'failed';

export interface LearningReportSummary {
    id: string;
    period: ReportPeriod;
    kind: ReportKind;
    periodStart: string;
    periodEnd: string;
    status: ReportStatus;
    readAt: string | null;
    generatedAt: string | null;
    language: string;
}

export interface LearningReportDetail extends LearningReportSummary {
    aiContent: string | null;
    recommendedCourseId: string | null;
    recommendationReason: string | null;
    snapshot: unknown | null;
}

export async function listLearningReports(limit = 50, offset = 0): Promise<LearningReportSummary[]> {
    const res = await apiClient.get<{ items: LearningReportSummary[] }>('/learning-reports', {
        params: { limit, offset },
    });
    return res.data.items;
}

export async function getLearningReport(id: string): Promise<LearningReportDetail> {
    const res = await apiClient.get<LearningReportDetail>(`/learning-reports/${id}`);
    return res.data;
}

export async function markLearningReportRead(id: string): Promise<void> {
    await apiClient.post(`/learning-reports/${id}/read`);
}
